/**
 * @description Примесь о внешних контактах.
 */
export default {
  supportEmailHref: 'mailto:mis@32top.ru',
  supportEmailTitle: 'mis@32top.ru',
  supportPhoneHref: 'tel:+79617210271',
  supportPhoneTitle: '+7 (961) 721-02-71',
  supportWhatsappHref: 'https://wa.me/79617210271/',
  supportTelegramHref: 'https://t.me/mis_32top',
};
